import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.2\" clip-path=\"url(#a)\"><path d=\"M14.75 8.833V4.667a.834.834 0 0 0-.834-.834H7.25a.833.833 0 0 0-.833.834V8\"></path><path d=\"M6.417 8V4.667H4.75a2.5 2.5 0 0 0-2.5 2.5V10.5a.833.833 0 0 0 .833.833H3.5\"></path><path d=\"M2.25 8h1.667a.833.833 0 0 0 .833-.833v-2.5M4.75 10.917a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M11.417 10.917a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0M8.5 11.333h1.667\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M1.834 1.333h13.332v13.333H1.834z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }